import { Banner } from "@alpacahq/ui/old";

import type { FAQItem } from "~/v2/components/common/FAQ";

export const ORIGINATING_BROKER_FAQ: FAQItem[] = [
  {
    question: "What if I don't see my outside broker under Originating Broker?",
    answer: (
      <>
        Please select “Other” as your brokerage then provide the name and the
        DTC number of your outside brokerage firm.
        <br />
        <Banner
          variant="info"
          message="A DTC number is the unique 4 digit number assigned to each clearing
          broker by DTCC. This number is used to facilitate transfers by
          identifying which broker the assets should be sent to or requested
          from."
        />
        <br />
        <br />
        You can find your brokerage's DTC number by looking it up on their FAQ
        page or contacting them directly.
      </>
    ),
  },
  {
    question: "What types of accounts are supported?",
    answer: (
      <>
        We support transferring into individual trading, Roth IRA, and
        Traditional IRA accounts. For incoming Portfolio transfers, we also
        support transferring a joint account into an individual trading account
        held at Alpaca.
      </>
    ),
  },
];
